import * as React from 'react';
import { Spin } from 'antd';

interface Props {
  loading: boolean;
  children: any;
}

import './LoadableContent.less';

const LoadableContent: React.FunctionComponent<Props> = ({
  loading,
  children,
}) => {
  return loading ? (
    <div className="loadable-content">
      <Spin size="large" />
    </div>
  ) : (
    children
  );
};

export default LoadableContent;



// WEBPACK FOOTER //
// ./src/components/LoadableContent/LoadableContent.tsx